<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_v"></a>CONTENTS</h2>
<p class="line1"> </p>
<p class="toc"><a href="#/xhtml/04_Foreword#for"><span class="bold">FOREWORD</span></a></p>
<p class="toc"><a href="#/xhtml/05_Introduction#int"><span class="bold">INTRODUCTION</span></a></p>
<p class="toc"><span href="#/xhtml/06_Dictionary#dic" title="Link target outside of Sample"><span class="bold">DICTIONARY</span></span></p>
<p class="toc"><span href="#/xhtml/07_Bibliography#bib" title="Link target outside of Sample"><span class="bold">BIBLIOGRAPHY OF PRINCIPAL SOURCES</span></span></p>
<p class="toc"><span href="#/xhtml/08_Additional#add" title="Link target outside of Sample"><span class="bold">ADDITIONAL BIBLIOGRAPHY</span></span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Contents.vue?29eb70c2